<template>
  <b-button-group>
    <b-button placement="bottom" v-b-tooltip.hover @click="emit('convertToBlock')" title="Convert to Text Block" variant="clear" >
      <i class="fa fa-object-group" aria-hidden="true"></i>
    </b-button>
  </b-button-group>
</template>

<script>

  export default {
    methods:{
      emit(event, value) {
        this.bus.$emit(event, value);
      }
    },
    props: ['bus']
  }
</script>

<style scoped>
  .btn-clear {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 8px 15px;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/editor/inlineControls/TextBlock.vue